import { useCallback } from 'react';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';
import { CampaignMessage } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';
import { WebsiteContentMessage } from 'sections/onsite-campaigns/types';

export const useGetDisplayWebContentSelector = () => {
  const state = useGetEditOrActual();
  return useCallback((id: string): CampaignMessage<WebsiteContentMessage> => state.messages[id], [state.messages]);
};
